import URI from 'urijs'

export default
function (ngModule) {
    ngModule.directive('newsDocumentCard', [function(){
        return {
            restrict: 'E',
            template: require('./mw-card.html'),
            controllerAs: 'vm',
            controller: 'NewsDocumentCardController',
            scope: {
                document: '=?',
                displaySettings: '=',
                showDuplicates: '&',
                documentClick: '&',
                overlaySentiment: '&',
                onBylineClick: '&?',
                isInfluencerDatabaseEntitled: '=',
                isSocialEchoEntitled: '=',
                isSocialEchoTop25Entitled: '=',
                socialEchoSortingSelected: '=',
                icmBaseUrl: '@?',
                socialEchoData: '&',
                isNarrowCard: '=',
                showFooter: '=',
                showOpenDocumentIcon: '=',
                minimumImageSize: '=',
                smallTextLimit: '=?'
            }
        };
    }])
    .controller('NewsDocumentCardController', [
        '$scope',
        'ContentBehaviorService',
        'translationService',
        'GeoService',
        'FeatureToggleService',
        'ENV_FEATURE_TOGGLE_SETTINGS',
        NewsDocumentCardController
    ]);

    function NewsDocumentCardController($scope, ContentBehaviorService, translationService, GeoService, FeatureToggleService, ENV_FEATURE_TOGGLE_SETTINGS) {

        this.showHideUnhideOption = false;
        //retrieving toggle synchronously
        if (ENV_FEATURE_TOGGLE_SETTINGS && ENV_FEATURE_TOGGLE_SETTINGS.hideUnhideDocumentsToggle && ENV_FEATURE_TOGGLE_SETTINGS.hideUnhideDocumentsToggle.active) {
            this.showHideUnhideOption = true;
        }
        this.mediaAvailable = false;
        this.socialEchoDataVisible = false;

        this.onMediaAvailable = function onMediaAvailable() {
            this.mediaAvailable = true;
        }.bind(this);

        this.imageAvailableOptions = {
            onMediaAvailable: this.onMediaAvailable,
            minimumImageSize: $scope.minimumImageSize
        };

        function getAuthorName(author) {
            if(author.authorInfo && author.authorInfo.structuredName && author.authorInfo.structuredName.firstName && author.authorInfo.structuredName.lastName) {
                return author.authorInfo.structuredName.firstName + (author.authorInfo.structuredName.middleName ? ' ' + author.authorInfo.structuredName.middleName : '') + ' ' + author.authorInfo.structuredName.lastName;
            }
            else if($scope.document.sourceId && $scope.document.sourceId.indexOf('adhoc:') > -1 && (!author.authorInfo || !author.authorInfo.structuredName) && author.name) {
                return author.name;
            }
        }

        function getAuthors(document) {
            if(!document.authors) {
                return [];
            }

            return document.authors.reduce(function(authors, author) {
                var isAuthorClickable = !!(author.id && $scope.isInfluencerDatabaseEntitled),
                    baseUrl = $scope.icmBaseUrl ? ($scope.icmBaseUrl + '/') : '',
                    contactUrl = '';

                if(isAuthorClickable) {
                    contactUrl = baseUrl + 'influencers/contact/view/' + author.id;
                }

                if(getAuthorName(author)) {
                    authors.push({
                        name: getAuthorName(author),
                        url: contactUrl,
                        onClick: function onClick() {
                            if(isAuthorClickable && typeof($scope.onBylineClick) === 'function') {
                                $scope.onBylineClick({ author: author });
                            }
                        }
                    });
                }

                return authors;
            }, []);
        }


        function onDocumentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        }

        function getLocalizedMoreArticlesText(count) {
            var moreArticleText = "";
            if (count > 0) {
                if (count === 1) {
                    moreArticleText = translationService.getLocalizedString('1 more article');
                } else {
                    moreArticleText = translationService.getLocalizedString('[[numArticles]] more articles', {numArticles: count})
                }
                return moreArticleText;
            }
        }

        var update = function update() {
            var hiddenDupDocsCount = 0;

            this.document = $scope.document;
            this.documentId = $scope.document.documentId;
            //Redirect Url before paywall because there are content streams where it provices click tracking
            this.documentUrl = $scope.document.redirectUrl || $scope.document.paywallUrl || $scope.document.url || $scope.document.sourceUrl;

            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.socialEchoVisible = $scope.displaySettings.socialEcho;
            this.isRestrictedDocument = $scope.document.restriction && $scope.document.restriction !== 'NOT_RESTRICTED';

            this.smallTextLimit = $scope.smallTextLimit || 750;

            var self = this;
            FeatureToggleService.isOn('newsDocumentCardImages')
                .then(function(isEnabled) {
                    if(isEnabled) {
                        self.image = isEnabled && self.imagesVisible && self.document && self.document.images && self.document.images.length > 0 && self.document.images[0].link
                            ? self.document.images[0].link
                            : undefined;
                    }
                })
            .catch(function(error) {
                console.error('There was a problem retrieving the state of newsDocumentCardImages toggle: ' + error);
            });

            this.isNarrowCard = $scope.isNarrowCard;

            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;

            this.mediaType = $scope.document.mediaType;
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;

            this.avatarTitle = $scope.document.title;

            if($scope.document.sourceUrl) {
                var uri =  new URI($scope.document.sourceUrl).origin()
                self.avatarImageUrl = `https://shuhari-iconoclast-production.herokuapp.com/favicon?size=48&url=${uri}`
            }

            if($scope.document.provider === 'dowjones') {
                self.avatarImageUrl = 'https://assets.meltwater.io/premium-content/dowjones.png'
            }
            if($scope.document.sourceUrl === 'www.weibo.com') {
                self.avatarImageUrl = 'https://assets.meltwater.io/custom-avatars/weibo-logo.png';
            }
            if($scope.document.sourceUrl === 'www.wechat.com') {
                self.avatarImageUrl = 'https://assets.meltwater.io/custom-avatars/wechat-logo.png';
            }

            this.avatarLinkUrl = this.documentUrl;

            this.sourceName = $scope.document.source || translationService.getLocalizedString('Unknown');
            this.sourceUrl = $scope.document.sourceUrl;

            this.authors = getAuthors($scope.document);

            GeoService.convertCountryCodeToCode3($scope.document.country).then(function(code) {
                this.countryCode = code;
            }.bind(this));

            this.date = $scope.document.date;

            this.title = $scope.document.title;
            //Overlay for matchSentence
            var matchSentence = $scope.document.matchSentence || $scope.document.tagContextMatchSentence || '';
            var openingText;
            if($scope.document.sourceId && $scope.document.sourceId.indexOf('adhoc:') > -1){
                var ingress = $scope.document.ingress;
                if(ingress) {
                    if(ingress.indexOf('...', ingress.length - 3) > -1) {
                        ingress = ingress.slice(0, ingress.length - 3);
                    }

                    // so the openingText is the ingress as long as the matchsentence does not contain
                    // the ingress (minus some ellipsis)
                    if(matchSentence.indexOf(ingress) === -1 ) {
                        openingText = ingress;
                    }
                }
            } else {
                openingText = $scope.document.ingress;
            }

            this.text = [];
            if ($scope.displaySettings.hitSentence && matchSentence) {
                this.text.push(matchSentence)
            }

            this.smallText = [];
            if ($scope.displaySettings.openingText && openingText) {
                this.smallText.push(openingText)
            }

            this.tags = ($scope.displaySettings.displayTags && $scope.document.tags) || [];

            this.keywords = ($scope.displaySettings.keywords && ($scope.document.keywords || $scope.document.tagContextKeywords)) || [];

            this.dupDocsCount = $scope.document.dupDocsCount || ($scope.document.dupDocs && $scope.document.dupDocs.length) || 0;

            if (this.showHideUnhideOption) {

                hiddenDupDocsCount = angular.isArray($scope.document.dupDocs) && $scope.document.dupDocs.length ? $scope.document.dupDocs.filter(function (dupDoc) {
                    return dupDoc.isHidden;
                }).length : 0;

                this.visibleDupDocsCount = this.dupDocsCount - hiddenDupDocsCount;

                //not using ng-pluralize with ContentBehaviorService.generateMoreArticleObject
                //since we need to update the number with hide and unhide.
                //see: http://stackoverflow.com/questions/22339108/ng-pluralize-when-bound-to-a-variable

                this.moreArticlesLinkText = getLocalizedMoreArticlesText(this.visibleDupDocsCount);
            } else {
                this.dupDocsCountWhen = ContentBehaviorService.generateMoreArticleObject($scope.document);
            }


            this.reach = $scope.document.reach;

            if ($scope.isSocialEchoEntitled && $scope.document) {
                if ($scope.document.socialScores) {
                    this.twitterCount = $scope.document.socialScores.tw_shares;
                    this.facebookCount = $scope.document.socialScores.fb_shares;
                } else {
                    this.twitterCount = 0;
                    this.facebookCount = 0;
                }
            }

            this.sentiment = $scope.document.sentiment;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;

            this.onAvatarClick = onDocumentClick.bind(this, this.avatarLinkUrl);
            this.onSourceIconClick = onDocumentClick.bind(this, this.documentUrl);
            this.onSourceNameClick = onDocumentClick.bind(this, $scope.document.sourceUrl);
            this.onDocumentOpenClick = onDocumentClick.bind(this, this.documentUrl);
            this.onTitleClick = onDocumentClick.bind(this, this.documentUrl);

            this.onOverlaySentimentClick = $scope.overlaySentiment;
            this.onShowDuplicatesClick = function (e) {
                return $scope.showDuplicates({
                    documentId: $scope.document.documentId
                });
            };

        }.bind(this);

        this.isSocialEchoVisible = function (document) {
            // This cutOffDate is the 1th of April. Before that, no social-echo values are available
            const cutOffDate = 1522540800000;
            return this.socialEchoVisible && (document.date > cutOffDate) && $scope.isSocialEchoEntitled;

        }.bind(this);

        this.onSocialEchoDataClick = function() {
            this.socialEchoDataVisible = !this.socialEchoDataVisible;
        }.bind(this);

        $scope.$watch('document', update, true);
        $scope.$watch('displaySettings', update, true);
        $scope.$watch('isInfluencerDatabaseEntitled', update, true);

        update();
    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/news-document-card.js